import { required } from "../../shared/src/codecs/types/required";
import { integer } from "../../shared/src/codecs/types/integer";
import { TTypeOfCodec } from "../../shared/src/codecs/codec";

export const CLCAuditSummary = required({
    open_files: integer(),
    completed_last_2_months: integer(),
    abs_case_pairs: integer(),
    funders_awaiting_source_of_wealth: integer(),
    referral_agreements_overdue: integer(),
    referral_agreements_missing: integer(),
});

export type TCLCAuditSummary = TTypeOfCodec<typeof CLCAuditSummary>;
